import Head from './../components/Head';
import dayjs from 'dayjs';
import Footer from '../components/Footer.vue';
import { Empty } from 'zhs-components';
import { handleLogin, handleLogout, getUrlParams, getLoginUrl } from '@/plugins/utils';
import { getStorage } from '@/plugins/store';
export default {
  created() {
    this.getNewsTypeList();
    this.getNewsList();
  },

  components: {
    Head,
    Footer,
    Empty
  },

  data() {
    return {
      menuId: this.$utils.getUrlParams('menuId'),
      newsList: [],
      newsTypeList: [],
      pageInfo: {
        pageIndex: 1,
        rows: 0,
        pageLimit: 10,
        newsTypeId: ''
      },
      newsName: '',
      showSearchResult: false,
      title: '',
      menuInfo: {},
      zhsRole: 0
    };
  },

  computed: {
    schoolId() {
      const res = getStorage('projectBaseData');
      return res.school_id ? res.school_id : 0;
    }

  },
  methods: {
    async getNewsTypeList() {
      const newsTypeList = await this.$http.getNewsClass({
        menu_id: this.menuId
      });
      console.log('分类', newsTypeList);
      this.newsTypeList = newsTypeList.content;
    },

    // 秒转换为几时几分几秒, 没超过1小时不显示时
    formatTime(time) {
      const h = Math.floor(time / 60 / 60);
      const m = Math.floor(time / 60 % 60);
      const s = Math.floor(time % 60);
      return `${h > 0 ? h + '时' : ''}${m}分${s}秒`;
    },

    async getNewsList() {
      const params = {
        '_pageable.page': this.pageInfo.pageIndex - 1,
        '_pageable.size': this.pageInfo.pageLimit,
        menu_id: this.menuId,
        news_name: this.newsName || undefined,
        classify_id: this.pageInfo.newsTypeId || undefined
      };
      const res = await this.$http.getNewsList(params);
      console.log('新闻列表', res);
      this.newsList = res.content;
      const new_ids = res.content.map(item => item.id);
      const res2 = await this.$http.getWatchRecord({
        news_ids: new_ids.join(',')
      });
      this.newsList = this.newsList.map(item => {
        const watchinfo = res2.find(item2 => item2.news_id === item.id);
        return { ...item,
          is_video: watchinfo && watchinfo.watch_time > 0 && watchinfo.total_time > 0,
          watch_time: watchinfo ? watchinfo.watch_time : 0,
          total_time: watchinfo ? watchinfo.total_time : 0,
          progress: watchinfo && watchinfo.total_time ? parseInt(watchinfo.watch_time / watchinfo.total_time * 100) : 0
        };
      });
      console.log(this.newsList, 'this.newsList');
      this.pageInfo.rows = +res.totalElements;
    },

    // 切换分页
    pageIndexChange(current) {
      this.pageInfo.pageIndex = current;
      this.getNewsList();
    },

    // 搜索
    handleSearch(newsTypeId = '') {
      this.pageInfo.pageIndex = 1;
      this.pageInfo.newsTypeId = newsTypeId;
      this.getNewsList();
      this.showSearchResult = true;
    },

    // 关键字高亮
    kewordFilter(value) {
      if (!value) return '';
      if (!this.newsName) return value;
      let reg = new RegExp(this.newsName, 'g');
      return value.replace(reg, `<span class="theme-color">${this.newsName}</span>`);
    },

    // 格式化新闻内容
    formateNews(data) {
      let result = this.$utils.getContentText(data);
      return this.kewordFilter(result);
    },

    // 增加观看次数
    async addViewCount(id) {
      const res = await this.$http.addViewCount({
        id
      }, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      console.log("count", res);
    },

    getZhsRole(data) {
      this.zhsRole = data || 0;
    },

    handleLogin,

    // 点击卡片进去详情页
    showNewsDetail(item) {
      if (this.schoolId == 506) {
        const scope = item.scope || 0; // 未登录状态下，选择非公开范围时，阻止切换并跳转登录

        if (scope > 0 && this.zhsRole == 0) {
          this.handleLogin();
          return false; // 阻止切换
        } // 角色为老师时,选择学生可见时，阻止切换


        if (scope == 2 && this.zhsRole == 2) {
          ElMessage.warning('该记录仅学生可访问，请查看其他内容');
          return false; // 阻止切换
        } // 角色为学生时,选择老师可见时，阻止切换


        if (scope == 1 && this.zhsRole == 3) {
          ElMessage.warning('该记录仅教师可访问，请查看其他内容');
          return false; // 阻止切换
        }
      }

      if (item.news_type === 1) {
        window.location.href = `/noticeDetail.html?id=${item.id}&menuId=${this.menuId}&name=${this.menuInfo.nav_name}`;
      } else {
        this.addViewCount(item.id);
        window.open(item.news_url);
      }
    },

    dayjs
  }
};